export { default, IHeartIconProps } from './HeartIcon';
